import { render, staticRenderFns } from "./PatientDetailContact.vue?vue&type=template&id=7af81c34"
import script from "./PatientDetailContact.vue?vue&type=script&lang=js"
export * from "./PatientDetailContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports